"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  display: block;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SpacingWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.spacing;
});

var Spacer = function Spacer(_ref) {
  var spacing = _ref.spacing;
  return /*#__PURE__*/_react["default"].createElement(SpacingWrapper, {
    spacing: spacing
  }, "\xA0 ");
};

Spacer.propTypes = {
  spacing: _propTypes["default"].string.isRequired
};
var _default = Spacer;
exports["default"] = _default;